import { render, staticRenderFns } from "./log_info.vue?vue&type=template&id=1612d22a&scoped=true&"
import script from "./log_info.vue?vue&type=script&lang=js&"
export * from "./log_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1612d22a",
  null
  
)

export default component.exports